const ScoreDividingLine = () => {
  return <div className={'border border-eaeaea my-auto h-12'} />
}

export default ScoreDividingLine
